import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import { bem } from 'helpers/class-name';

import { intlMessage } from 'constants/propTypes';
import Message from 'components/Message';
import { SvgArrow } from 'components/Svgs';
import messages from '../ReservationFeedbackModalV2.messages';

import './ReportBadge.scss';

const { block, element } = bem('report-badge');

const ReportBadge = ({ isExpanded, isToggle, label, onClick, openStateLabel, closeStateLabel, text }) => {
  const intl = useIntl();
  const collapseAriaLabel = intl.formatMessage(messages.collapseGuidancePanelAriaLabel);
  const expandAriaLabel = intl.formatMessage(messages.expandGuidancePanelAriaLabel);

  const badgeContent = (
    <div className={element('content', { 'is-expanded': isToggle && isExpanded })}>
      <div className={element('text-wrapper')}>
        {label && <Message as="div" className={element('label')} message={label} />}
        {isToggle && (
          <Message
            as="span"
            className={element('toggle-label')}
            message={isExpanded ? openStateLabel : closeStateLabel}
          />
        )}
        <Message as="div" className={element('text')} message={text} />
      </div>
      {isToggle && <SvgArrow className={element('arrow')} direction={isExpanded ? 'up' : 'down'} theme="brand" />}
    </div>
  );

  return isToggle ? (
    <button
      className={element('toggle')}
      onClick={onClick}
      type="button"
      aria-expanded={isExpanded}
      aria-controls="guidance-panel-mobile"
      aria-label={isExpanded ? collapseAriaLabel : expandAriaLabel}>
      {badgeContent}
    </button>
  ) : (
    <div className={block()}>{badgeContent}</div>
  );
};

ReportBadge.propTypes = {
  closeStateLabel: intlMessage,
  isExpanded: PropTypes.bool,
  isToggle: PropTypes.bool,
  label: intlMessage,
  onClick: PropTypes.func,
  openStateLabel: intlMessage,
  text: intlMessage.isRequired,
};

export default ReportBadge;
